import apiClient from './config';

const TEACHER_BASE = '/teacher';

// ============================================
// TEACHER API ENDPOINTS
// ============================================

// Grade Management
export const teacherGradeAPI = {
  createGrade: (data) => apiClient.post(`${TEACHER_BASE}/grades`, data),
  getGrades: () => apiClient.get(`${TEACHER_BASE}/grades`),
};

// Subject Management
export const teacherSubjectAPI = {
  createSubject: (data) => apiClient.post(`${TEACHER_BASE}/subjects`, data),
  getSubjects: () => apiClient.get(`${TEACHER_BASE}/subjects`),
  updateSubject: (subjectId, data) => apiClient.put(`${TEACHER_BASE}/subjects/${subjectId}`, data),
  deleteSubject: (subjectId) => apiClient.delete(`${TEACHER_BASE}/subjects/${subjectId}`),
};

// Course Content Management
export const teacherCourseAPI = {
  createCourse: (formData, onUploadProgress) => apiClient.post(`${TEACHER_BASE}/course-contents`, formData, {
    onUploadProgress: onUploadProgress
  }),
  getCourses: (params) => apiClient.get(`${TEACHER_BASE}/course-contents`, { params }),
  getCourse: (courseId) => apiClient.get(`${TEACHER_BASE}/course-contents/${courseId}`),
  updateCourse: (courseId, formData, onUploadProgress) => apiClient.put(`${TEACHER_BASE}/course-contents/${courseId}`, formData, {
    onUploadProgress: onUploadProgress
  }),
  deleteCourse: (courseId) => apiClient.delete(`${TEACHER_BASE}/course-contents/${courseId}`),
  publishCourse: (courseId) => apiClient.post(`${TEACHER_BASE}/course-contents/${courseId}/publish`),
  unpublishCourse: (courseId) => apiClient.post(`${TEACHER_BASE}/course-contents/${courseId}/unpublish`),
};

// Video Management
export const teacherVideoAPI = {
  uploadVideo: (courseId, formData, onUploadProgress) => 
    apiClient.post(`${TEACHER_BASE}/course-contents/${courseId}/videos`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress,
    }),
  deleteVideo: (courseId, videoId) => 
    apiClient.delete(`${TEACHER_BASE}/course-contents/${courseId}/videos/${videoId}`),
};

// File Management
export const teacherFileAPI = {
  uploadFile: (courseId, formData, onUploadProgress) => 
    apiClient.post(`${TEACHER_BASE}/course-contents/${courseId}/files`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress,
    }),
  deleteFile: (courseId, fileId) => 
    apiClient.delete(`${TEACHER_BASE}/course-contents/${courseId}/files/${fileId}`),
};

// Quiz Management
export const teacherQuizAPI = {
  createQuiz: (courseId, data) => 
    apiClient.post(`${TEACHER_BASE}/course-contents/${courseId}/quizzes`, data),
  getQuizDetails: (quizId) => apiClient.get(`${TEACHER_BASE}/quizzes/${quizId}`),
  addQuestion: (quizId, data) => 
    apiClient.post(`${TEACHER_BASE}/quizzes/${quizId}/questions`, data),
  addOption: (questionId, data) => 
    apiClient.post(`${TEACHER_BASE}/questions/${questionId}/options`, data),
};

// Dashboard
export const teacherDashboardAPI = {
  getDashboard: () => apiClient.get(`${TEACHER_BASE}/dashboard`),
};
